module.exports = __webpack_public_path__ + "static/img/loca-competition.26d230b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/loca-competition.jpg
// module id = CPj2
// module chunks = 0